import { ReactNode } from 'react';
import { BreadCrumb } from '../BreadCrumb';

interface Props {
	children?: ReactNode;
	pageTitle: string;
	breadcrumbs: JSX.Element[];
}

const PageHeader = ({children, pageTitle, breadcrumbs} : Props) => {
	return (
		<div className='md:flex justify-between mt-2 md:px-4 items-center'>
            <div className='flex flex-col md:flex-row items-center justify-between md:justify-start space-x-4'>
                <h1 className='text-gray-600 h-auto font-semibold text-xl md:text-3xl pr-2 flex items-center'>
                    {pageTitle}
                </h1>
                <BreadCrumb breadcrumbs={breadcrumbs} />
            </div>

            <div className='mt-2 py-4'>
            { children }
            </div>
		</div>
	);
};

export default PageHeader;
